import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'

export const infocollectionTypes = createTypes(['SET_KEY', 'SET_KEY_MULTI', 'REMOVE_KEY', 'ADD_BENEFICIARY', 'REMOVE_BENEFICIARY'], 'INFO_COLLECTION');


export const setInfoKey = (keyValue, customerId) => {
    return {
        type: infocollectionTypes.SET_KEY,
        key: keyValue.key,
        value: keyValue.value,
        customerId: customerId,
    };
};

export const addBeneficiary = (keyValue, customerId) => {
    return {
        type: infocollectionTypes.ADD_BENEFICIARY,
        key: keyValue.key,
        value: keyValue.value,
        customerId: customerId,
    };
};

export const removeSingleBeneficiary = (keyValue, customerId) => {
    return {
        type: infocollectionTypes.REMOVE_BENEFICIARY,
        key: keyValue.key,
        value: keyValue.value,
        customerId: customerId,
    };
};

export const removeInfoKey = (key, customerId) => {
    return {
        type: infocollectionTypes.REMOVE_KEY,
        key: key,
        customerId: customerId,
    };
};

export const setInfoKeyMulti = (obj, customerId) => {
    return {
        type: infocollectionTypes.SET_KEY_MULTI,
        data: obj,
        customerId: customerId,
    }
}

